const state = {
  searchParams: {
    celebrations: {},
    customers: {},
    invoices: {}
  }
}

// Getters
const getters = {
  // UserData
  searchParams: (state) => (page) => {
    return state.searchParams[page]
  }
}

// Mutations
const mutations = {
  'SET_SEARCH_PARAMS' (state, searchParams) {
    state.searchParams[searchParams.page] = searchParams.params
  }
}

export default {
  state,
  getters,
  mutations
}
